import React, { Children } from 'react'
import { Link } from 'react-router-dom';


const SliderTestContainer = ({ containerObject, dataZone, templateName, contentId }) => {
    var content = containerObject;
    
    var articleItem = containerObject.SliderContainer 
     
        return (

            <>
               

               <div  data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row `}>

                {/* <!--product Listing section start Using Testimonial component without changing class name--> */}
                <section class="testimonial-section ptb-40 bg-light">
                    <div class="container">
                        <div class="row justify-content-center align-content-center">
                            <div class="col-md-10 col-lg-6">
                                <div class="section-heading text-center">
                                    <h4 class="h5 text-primary" dangerouslySetInnerHTML={{ __html: content.containerTitle }}></h4>
                                    <h2 dangerouslySetInnerHTML={{ __html: content.containerSubTitle }}></h2>
                                    <p dangerouslySetInnerHTML={{ __html: content.containerBody }}></p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="position-relative w-100">
                                    <div class="swiper testimonialSwiper">
                                        <div class="swiper-wrapper">

                                         {articleItem ? articleItem.map((item)=>{
                                           return(
                                           <div class="swiper-slide">
                                                <div class="single-article rounded-custom my-3">
                                                    <Link to={`${item.attributes.linkUrl}`} class="article-img">
                                                        <img src={`${item.mainImage ? item.mainImage : ""}`} alt="article" class="img-fluid" />
                                                    </Link>
                                                    <div class="article-content p-4">
                                                        <Link to={`${item.attributes.linkUrl}`}>
                                                            <h2 class="h5 article-title limit-2-line-text">{item.attributes.header}
                                                                {/* <span dangerouslySetInnerHTML={{ __html: item.header }}></span> */}
                                                            </h2>
                                                        </Link>
                                                        <div class="article-category mb-2 d-block">
                                                            <Link to="javascript:;" class="d-inline-block text-dark badge bg-warning-soft">{item.attributes.subheader}
                                                                {/* <span dangerouslySetInnerHTML={{ __html: item.subheader }}></span> */}
                                                            </Link>
                                                        </div>

                                                        <p class="limit-2-line-text">{item.attributes.body}
                                                            {/* <span dangerouslySetInnerHTML={{ __html: item.body }}></span> */}
                                                        </p>

                                                        <Link to={`${item.attributes.linkUrl}`} class="ins-service-explore fs-md fw-bold">Explore More
                                                            <span class="ms-1">
                                                                <svg width="53" height="9" viewBox="0 0 53 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M0.104523 4.57166L48.8984 4.57166" stroke="#003478" stroke-width="0.995794" />
                                                                    <path d="M52.8787 4.57082L46.904 8.02035L46.904 1.12129L52.8787 4.57082Z" fill="#003478" />
                                                                </svg>
                                                            </span>
                                                        </Link>

                                                    </div>
                                                </div>

                                            </div>
                                           )
                                         })
                                         :"" } 
                                           
                                        </div>
                                    </div>
                                    <span class="swiper-button-next"></span>
                                    <span class="swiper-button-prev"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                </div>
                {/* product Listing section end */}

            </>
        )

        
    

   

}
export default SliderTestContainer